import React from "react";
import PropTypes from "prop-types";

import { APPLICATION_STATE, REJECTION_REASON } from "lib/constants";
import { applicationShape } from "lib/propTypes";

export default class RecentApps extends React.PureComponent {
    static propTypes = {
        apps: PropTypes.arrayOf(applicationShape).isRequired,
    };

    renderApps() {
        if (this.props.apps.length === 0) {
            return <span className="cand-home__recent-apps-empty">No other applications</span>;
        }

        const apps = this.props.apps.map((app) => (
            <div className="cand-home__recent-apps-row" key={app.id}>
                <div className="cand-home__recent-apps-info">
                    <p className="cand-home__recent-apps-title">{app.position.title}</p>
                    <p>{app.position.company_name}</p>
                </div>
                <div className="cand-home__recent-apps-state">{this.renderAppState(app)}</div>
            </div>
        ));

        return <div className="cand-home__recent-apps-list">{apps}</div>;
    }

    renderAppState(app) {
        if (app.state === APPLICATION_STATE.STARTED) {
            return <a href={`/app/start?sn=2&p=${app.position.id}`}>Not Submitted</a>;
        }

        if (app.state === APPLICATION_STATE.HIRE_PENDING) {
            return "Moving Forward";
        }

        if (app.state === APPLICATION_STATE.CANCELED) {
            return "Canceled";
        }

        if (app.sms_regretted && app.reason === REJECTION_REASON.EXPIRED) {
            return "Expired";
        }

        if (app.sms_regretted) {
            return "Declined";
        }

        if (app.time_interview_schedule !== null) {
            return "Interview Completed";
        }

        if (app.time_approved !== null) {
            return "In Review";
        }

        return "In Process";
    }

    render() {
        return (
            <section className="cand-home__recent-apps">
                <h1 className="section-title">Recent Applications</h1>
                {this.renderApps()}
                <footer>
                    <a href="/my-applications/" className="btn btn-large btn--white">
                        View all
                    </a>
                </footer>
            </section>
        );
    }
}
